export const questionMixin = {
  methods: {
    getAnswerValue(answerItem) {
      return answerItem.value.trim() === "wrong" ||
        answerItem.value.trim() === "right"
        ? answerItem.key
        : answerItem.value;
    }
  }
};
